module.exports = __webpack_public_path__ + "img/52_32.e7211887.png";